import cloneDeep from 'lodash/cloneDeep';
import { call, select } from 'redux-saga/effects';

import { PURCHASE_METHOD_CASH } from '../../constants/payment';
import { getPaymentOptions, getFinanceOptions } from '../selectors';
import updatePaymentOptions from './api/updatePaymentOptions';

function* selectCashPlan() {
    const paymentOptions = yield select(getPaymentOptions);
    const financeOptions = yield select(getFinanceOptions);

    // Deep copy
    const transformedFinanceOptions = cloneDeep(financeOptions);

    // Update isSelected values
    transformedFinanceOptions.forEach(fo => {
        fo.isSelected = false;
    });

    yield call(updatePaymentOptions, {
        ...paymentOptions,
        financePlan: null,
        purchaseMethod: PURCHASE_METHOD_CASH,
        financeOptions: transformedFinanceOptions
    });
}

export default selectCashPlan;
